import React from 'react';

const Loader = () => (
    <div className="flex justify-center items-center h-screen">
        <div className="loader">
            <img src="/logo-loader.gif" alt="loader" />
        </div>
    </div>
);

export default Loader;
